import React from "react";
// import _ from 'lodash'
// import MultiLineText from './MultiLineText';
import BG from "./6.png";

export default ({ currentLang, selectedType }) => {
  const shouldDisplayByLang = selectLang => {
    return currentLang === selectLang ? "display" : "display-none";
  };
  const shouldDisplayByType = type => {
    return selectedType === type || selectedType === "all"
      ? "opacity-in"
      : "opacity-out";
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 329.4 363.4"
      className="site-plan-svg"
    >
      <g id="map">
        <image xlinkHref={BG} height="100%" width="100%" />
      </g>
      <g id="floorplan">
        <g id="studio" className={shouldDisplayByType("studio")}>
          <polygon
            id="_1A_2605"
            data-name="1A_2605"
            points="108.1 97.7 133.9 97.7 133.9 119.6 122.9 119.6 122.9 124.6 108.2 124.6 108.1 97.7"
            fill="#231f20"
          />
          <polygon
            id="_1A_2606"
            data-name="1A_2606"
            points="94.5 133.9 94.5 144.6 99.8 144.6 99.8 159.3 72.6 159.3 72.6 133.9 94.5 133.9"
            fill="#231f20"
          />
        </g>
        <g id="one-bedroom" className={shouldDisplayByType("one-bedroom")}>
          <polygon
            id="_1Cx_2620"
            data-name="1Cx_2620"
            points="212.9 58.6 224.2 58.6 224.2 54.3 239.1 54.3 239.1 90.5 212.9 90.5 212.9 58.6"
            fill="#231f20"
          />
          <polygon
            id="_1Cx_2619"
            data-name="1Cx_2619"
            points="186.7 58.6 197.9 58.6 197.9 54.5 212.9 54.5 212.9 90.5 186.7 90.5 186.7 58.6"
            fill="#231f20"
          />
          <polygon
            id="_1D_2616"
            data-name="1D_2616"
            points="76.9 82.9 84.1 75.7 80.4 72 92.1 60.3 95.8 64 107.5 64 107.5 90.5 100.2 90.5 92.4 98.4 76.9 82.9"
            fill="#231f20"
          />
          <polygon
            id="_1D_2615"
            data-name="1D_2615"
            points="35.1 117.2 46.9 105.5 50.6 109.2 57.5 102.3 73 117.8 65.4 125.4 65.4 132.5 38.8 132.5 38.8 121.2 35.1 117.2"
            fill="#231f20"
          />
          <polygon
            id="_1Cx_2612"
            data-name="1Cx_2612"
            points="29.3 211.8 65.3 211.8 65.3 238 33.6 238 33.6 226.7 29.3 226.7 29.3 211.8"
            fill="#231f20"
          />
          <polygon
            id="_1C_2611"
            data-name="1C_2611"
            points="65.4 264.8 33.6 264.8 33.6 238 65.3 238 65.4 264.8"
            fill="#231f20"
          />
        </g>
        <g id="two-bedroom" className={shouldDisplayByType("two-bedroom")}>
          <polygon
            id="_2Bx2_2601"
            data-name="2Bx2_2601"
            points="252.2 97.7 291.5 97.7 291.5 129.7 264.6 129.7 264.6 124.8 252.2 124.8 252.2 97.7"
            fill="#231f20"
          />
          <polygon
            id="_2Cx1_2602"
            data-name="2Cx1_2602"
            points="213.5 97.7 252.2 97.7 252.2 134.4 225.3 134.4 225.3 129.6 213.5 129.6 213.5 97.7"
            fill="#231f20"
          />
          <polygon
            id="_2Bx2_2603"
            data-name="2Bx2_2603"
            points="174.2 97.7 213.5 97.7 213.5 129.6 186.1 129.6 186.1 124.8 174.2 124.8 174.2 97.7"
            fill="#231f20"
          />
          <rect
            id="_2C1_2604"
            data-name="2C1_2604"
            x="135.1"
            y="97.7"
            width="39.1"
            height="31.9"
            fill="#231f20"
          />
          <polygon
            id="_2Bx2_2607"
            data-name="2Bx2_2607"
            points="72.6 159.4 104.5 159.4 104.5 186.4 99.8 186.4 99.8 198.7 72.6 198.7 72.6 159.4"
            fill="#231f20"
          />
          <rect
            id="_2C1_2608"
            data-name="2C1_2608"
            x="72.6"
            y="198.7"
            width="31.9"
            height="38.58"
            fill="#231f20"
          />
          <polygon
            id="_2Cx2_2609"
            data-name="2Cx2_2609"
            points="109.3 238 109.3 264.9 104.5 264.9 104.5 276.8 72.6 276.8 72.6 238 109.3 238"
            fill="#231f20"
          />
          <polygon
            id="_2Bx1_2610"
            data-name="2Bx1_2610"
            points="99.8 316.6 72.6 316.6 72.6 276.8 104.5 276.8 104.5 304.2 99.8 304.2 99.8 316.6"
            fill="#231f20"
          />
          <polygon
            id="_2C1_2613"
            data-name="2C1_2613"
            points="33.6 172 65.6 172 65.6 211.8 33.5 211.8 33.6 172"
            fill="#231f20"
          />
          <polygon
            id="_2Cx2_2614"
            data-name="2Cx2_2614"
            points="28.8 133.2 65.6 133.2 65.6 172 33.6 172 33.6 160.1 28.8 160.1 28.8 133.2"
            fill="#231f20"
          />
          <polygon
            id="_2Cx1_2617"
            data-name="2Cx1_2617"
            points="108.1 58.6 120.5 58.6 120.5 53.9 147.4 53.9 147.4 90.5 108.1 90.5 108.1 58.6"
            fill="#231f20"
          />
          <polygon
            id="_2C2_2618"
            data-name="2C2_2618"
            points="159.7 58.6 186.7 58.6 186.7 90.5 147.4 90.5 147.4 58.6 159.7 58.6"
            fill="#231f20"
          />
        </g>
      </g>
      <g xmlns="http://www.w3.org/2000/svg" id="text">
        <g id="cn" className={shouldDisplayByLang("cn")}>
          <text
            transform="translate(266.9 141.5)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2601
          </text>
          <text
            transform="translate(227.1 141.5)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2602
          </text>
          <text
            transform="translate(190.3 141.5)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2603
          </text>
          <text
            transform="translate(147.8 141.5)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2604
          </text>
          <text
            transform="translate(116.8 133.2)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2605
          </text>
          <text
            transform="translate(107.3 149.4)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2606
          </text>
          <text
            transform="translate(112.8 175.5)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2607
          </text>
          <text
            transform="translate(112.8 217.8)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2608
          </text>
          <text
            transform="translate(112.8 258.8)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2609
          </text>
          <text
            transform="translate(112.8 299.1)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2610
          </text>
          <text
            transform="translate(71 65)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2616
          </text>
          <text
            transform="translate(29 105.2)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2615
          </text>
          <text
            transform="translate(121.9 48.6)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2617
          </text>
          <text
            transform="translate(161.1 48.6)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2618
          </text>
          <text
            transform="translate(195.1 48.6)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2619
          </text>
          <text
            transform="translate(221 48.6)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2620
          </text>
          <text
            transform="translate(12.7 156)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2614
          </text>
          <text
            transform="translate(12.7 194.1)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2613
          </text>
          <text
            transform="translate(12.7 226.9)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2612
          </text>
          <text
            transform="translate(12.7 253.5)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2611
          </text>
          <text
            transform="translate(194.2 217.5)"
            font-size="10"
            fill="#58595b"
            font-family="Termina-Bold, Termina Bold"
          >
            <tspan font-weight="700">6</tspan>
            <tspan
              x="5.1"
              y="0"
              font-family="STHeitiTC-Medium, STHeitiTC Medium"
            >
              楼
            </tspan>
          </text>
        </g>
        <g id="ru" className={shouldDisplayByLang("ru")}>
          <text
            transform="translate(266.9 141.5)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2601
          </text>
          <text
            transform="translate(227.1 141.5)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2602
          </text>
          <text
            transform="translate(190.3 141.5)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2603
          </text>
          <text
            transform="translate(147.7 141.5)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2604
          </text>
          <text
            transform="translate(116.8 133.2)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2605
          </text>
          <text
            transform="translate(107.2 149.5)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2606
          </text>
          <text
            transform="translate(112.7 175.5)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2607
          </text>
          <text
            transform="translate(112.7 217.8)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2608
          </text>
          <text
            transform="translate(112.7 258.8)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2609
          </text>
          <text
            transform="translate(112.7 299.1)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2610
          </text>
          <text
            transform="translate(71 65.1)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2616
          </text>
          <text
            transform="translate(29 105.2)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2615
          </text>
          <text
            transform="translate(121.8 48.7)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2617
          </text>
          <text
            transform="translate(161 48.7)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2618
          </text>
          <text
            transform="translate(195 48.7)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2619
          </text>
          <text
            transform="translate(220.9 48.7)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2620
          </text>
          <text
            transform="translate(12.6 156.1)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2614
          </text>
          <text
            transform="translate(12.6 194.1)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2613
          </text>
          <text
            transform="translate(12.6 226.9)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2612
          </text>
          <text
            transform="translate(12.6 253.5)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2611
          </text>
          <text
            transform="translate(186.4 217.5)"
            font-size="11"
            fill="#58595b"
            font-family="Helvetica-Bold, Helvetica"
            font-weight="700"
          >
            6-Й ЭТАЖ
          </text>
        </g>
        <g id="en" className={shouldDisplayByLang("en")}>
          <text
            transform="translate(266.9 141.5)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2601
          </text>
          <text
            transform="translate(227.1 141.5)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2602
          </text>
          <text
            transform="translate(190.3 141.5)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2603
          </text>
          <text
            transform="translate(147.7 141.5)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2604
          </text>
          <text
            transform="translate(116.8 133.2)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2605
          </text>
          <text
            transform="translate(107.2 149.5)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2606
          </text>
          <text
            transform="translate(112.7 175.5)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2607
          </text>
          <text
            transform="translate(112.7 217.8)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2608
          </text>
          <text
            transform="translate(112.7 258.8)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2609
          </text>
          <text
            transform="translate(112.7 299.1)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2610
          </text>
          <text
            transform="translate(71 65.1)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2616
          </text>
          <text
            transform="translate(29 105.2)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2615
          </text>
          <text
            transform="translate(121.8 48.7)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2617
          </text>
          <text
            transform="translate(161 48.7)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2618
          </text>
          <text
            transform="translate(195.1 48.7)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2619
          </text>
          <text
            transform="translate(221 48.7)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2620
          </text>
          <text
            transform="translate(12.6 156.1)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2614
          </text>
          <text
            transform="translate(12.6 194.1)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2613
          </text>
          <text
            transform="translate(12.6 226.9)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2612
          </text>
          <text
            transform="translate(12.6 253.5)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2611
          </text>
          <text
            transform="translate(183.1 217.5)"
            font-size="10"
            fill="#58595b"
            font-family="Termina-Bold, Termina Bold"
            font-weight="700"
          >
            6th Floor
          </text>
        </g>
      </g>
    </svg>
  );
};



// WEBPACK FOOTER //
// ./src/data/PhuketSkypark/sitePlan/svg/b/6.js